interface ConsentFlowOptions {
  isRegisterSignUp: boolean;
  isRegisterScreen: boolean;
  isPartnerFlow: boolean;
  isInvitationFlow: boolean;
  isWaitingList: boolean;
  isInvoicing: boolean;
}

export function getConsentFlow(options: Partial<ConsentFlowOptions>): string | undefined {
  if (options.isRegisterSignUp) return 'register_sign_up';
  if (options.isRegisterScreen) return 'register_screen';
  if (options.isPartnerFlow) return 'register_partners';
  if (options.isInvitationFlow) return 'invitation_flow';
  if (options.isWaitingList) return 'waiting_list';
  if (options.isInvoicing) return 'invoicing';
  return undefined;
}

interface TrackPartnerRegisterStartedOptions {
  organizationLegalCountry: string;
  legalFlow: string;
  organizationId: string;
  partnerName: string;
}

export function trackPartnerRegisterStarted(
  segment: any,
  {
    organizationLegalCountry,
    legalFlow,
    organizationId,
    partnerName,
  }: TrackPartnerRegisterStartedOptions
): void {
  let isCompanyCreation = legalFlow === 'company_creation';

  segment.track('onboarding_partner_register_started', {
    country_selected: organizationLegalCountry,
    situation: isCompanyCreation ? 'company_creation' : 'company',
    under_registration: isCompanyCreation,
    organization_id: organizationId,
    partner_name: partnerName,
  });
}
